import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { RuleCreatePayload } from '@rossum/api-client/rules';
import { useApiClient } from '../../../lib/apiClient';
import { RULES_QUERY_KEY } from './rulesQueryKeys';

export const useCreateRule = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries([RULES_QUERY_KEY]);
    },
    mutationFn: (rule: RuleCreatePayload) =>
      api.request(endpoints.rules.create(rule)),
  });
};
